import * as Caml_builtin_exceptions from "./caml_builtin_exceptions.js";

function caml_string_get(s, i) {
  if (i >= s.length || i < 0) {
    throw [Caml_builtin_exceptions.invalid_argument, "index out of bounds"];
  }

  return s.charCodeAt(i);
}

function caml_string_get16(s, i) {
  return s.charCodeAt(i) + (s.charCodeAt(i + 1 | 0) << 8) | 0;
}

function caml_string_get32(s, i) {
  return ((s.charCodeAt(i) + (s.charCodeAt(i + 1 | 0) << 8) | 0) + (s.charCodeAt(i + 2 | 0) << 16) | 0) + (s.charCodeAt(i + 3 | 0) << 24) | 0;
}

function get(s, i) {
  if (i < 0 || i >= s.length) {
    throw [Caml_builtin_exceptions.invalid_argument, "index out of bounds"];
  }

  return s.charCodeAt(i);
}

export { caml_string_get, caml_string_get16, caml_string_get32, get };
/* No side effect */